export const INLINE_HANDLING_FOR_SERVER_ERROR = [
  '/v2/policy/renewal_flag',
  '/schedule/appointment',
  '/policy/car/odo',
  '/payment/direct_debit'
];